import { render, staticRenderFns } from "./Step1.vue?vue&type=template&id=ded0c0fe&scoped=true&lang=pug&"
import script from "./Step1.vue?vue&type=script&lang=js&"
export * from "./Step1.vue?vue&type=script&lang=js&"
import style0 from "./Step1.vue?vue&type=style&index=0&id=ded0c0fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded0c0fe",
  null
  
)

export default component.exports